module.exports = __webpack_public_path__ + "img/54ne.fd9ad459.svg";